<template>
  <div class="signup">
    <h2 class="page__title">회원가입</h2>
    <form class="form" @submit.prevent>

      <div class="form__item">
        <label class="form__label">ID</label>
        <input
          class="form__input"
          type="text"
          v-model="userId"
          placeholder="아이디를 입력하세요"
          maxlength="20"
        />
        <!-- 안내 문구: 항상 표시 -->
        <span class="form__hint">영문자로 시작하는 영문/숫자 4~20자</span>
        <!-- 오류 문구: 입력 시작 후 형식이 틀릴 때만 표시 -->
        <span class="form__error" v-if="userId && !idValid">
          올바른 형식이 아닙니다. (영문자로 시작, 영문/숫자 4~20자)
        </span>
      </div>

      <div class="form__item">
        <label class="form__label">이름</label>
        <input
          class="form__input"
          type="text"
          v-model="userName"
          placeholder="이름을 입력하세요"
        />
      </div>

      <div class="form__item">
        <label class="form__label">이메일</label>
        <input
          class="form__input"
          type="email"
          v-model="userEmail"
          placeholder="이메일을 입력하세요"
        />
        <span class="form__error" v-if="userEmail && !emailValid">
          올바른 이메일 형식으로 입력해주세요.
        </span>
      </div>

      <div class="form__item">
        <label class="form__label">비밀번호</label>
        <input
          class="form__input"
          type="password"
          v-model="userPassword"
          placeholder="비밀번호를 입력하세요"
        />
        <!-- 안내 문구: 항상 표시 -->
        <span class="form__hint">영문자와 숫자를 포함한 8자 이상</span>
        <!-- 오류 문구: 입력 시작 후 형식이 틀릴 때만 표시 -->
        <span class="form__error" v-if="userPassword && !passwordValid">
          영문자와 숫자를 모두 포함하여 8자 이상 입력해주세요.
        </span>
      </div>

      <div class="form__item">
        <label class="form__label">비밀번호 확인</label>
        <input
          class="form__input"
          type="password"
          v-model="confirmPassword"
          placeholder="비밀번호를 다시 입력하세요"
        />
        <span class="form__error" v-if="confirmPassword && userPassword !== confirmPassword">
          비밀번호가 일치하지 않습니다.
        </span>
      </div>

      <div class="btn-wrap">
        <button class="btn btn--primary" type="button" @click="sendData" :disabled="!isValid">가입하기</button>
        <button class="btn btn--outline" type="button" @click="$router.push('/loginPage')">로그인으로 돌아가기</button>
      </div>

    </form>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'memberSubscribe',
  data() {
    return {
      userId: '',
      userName: '',
      userEmail: '',
      userPassword: '',
      confirmPassword: '',
    };
  },
  computed: {
    // 아이디: 영문자로 시작, 영문/숫자 4~20자
    idValid() {
      return /^[a-zA-Z][a-zA-Z0-9]{3,19}$/.test(this.userId);
    },
    // 이메일: 기본 형식 검증
    emailValid() {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.userEmail);
    },
    // 비밀번호: 영문 + 숫자 포함 8자 이상
    passwordValid() {
      return (
        this.userPassword.length >= 8 &&
        /[a-zA-Z]/.test(this.userPassword) &&
        /[0-9]/.test(this.userPassword)
      );
    },
    // 모든 조건 통과 시 가입 버튼 활성화
    isValid() {
      return (
        this.idValid &&
        this.userName.trim() !== '' &&
        this.emailValid &&
        this.passwordValid &&
        this.userPassword === this.confirmPassword
      );
    },
  },
  methods: {
    sendData() {
      if (!this.isValid) return;

      const data = {
        userId: this.userId,
        userName: this.userName,
        userEmail: this.userEmail,
        userPassword: this.userPassword,
      };

      axios
        .post(process.env.VUE_APP_API_SERVER_URL + '/api/savemembersubscribe', data)
        .then((response) => {
          if (response.status == 200) {
            this.$router.push('/welcomePage');
          }
        })
        .catch((error) => {
          console.error('회원가입 실패:', error);
          alert('회원가입 중 오류가 발생하였습니다.');
        });
    },
  },
};
</script>

<style scoped>
.signup { padding-bottom: 4rem; }
.form__hint {
  display: block;
  font-size: 1.1rem;
  color: #888;
  margin-top: 0.3rem;
}
.form__error {
  display: block;
  font-size: 1.1rem;
  color: #c0392b;
  margin-top: 0.3rem;
}
.btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
</style>
